import React from 'react';
import TransitStopRowForm from '@features/public-transit-editor/transit-management/Stops/TransitStopRowForm';
import { PublicTransitLayerEntityName } from '@api/entities/replancity_PublicTransitLine';
import { EntityServiceName } from '@api/enums/enums';
import EntitiesLoader from '../../../../entities/EntitiesLoader/EntitiesLoader';
import { BaseEntityNameLess } from '@api/entities/BaseEntity';

const getUrlFunc = ({ id }: any) => `./${id}`;

const TransitStopsList = ({
    showNewButton = true,
    hasLink = true,
    onRowClick,
}: {
    showNewButton?: boolean;
    hasLink?: boolean;
    onRowClick?: (entity: BaseEntityNameLess) => Promise<void>;
}) => {
    const entityName = PublicTransitLayerEntityName.STOPS;
    const serviceName = EntityServiceName.PUBLIC_TRANSIT;

    return (
        <EntitiesLoader
            entityName={entityName}
            layerEntityName={entityName}
            serviceName={serviceName}
            form={TransitStopRowForm}
            // linkable={true}
            getUrlFunc={getUrlFunc}
            zoomToRelatedFeatureBbox={true}
            showNewButton={showNewButton}
            hasLink={hasLink}
            onRowClick={onRowClick}
        />
    );
};

export default TransitStopsList;
